import { render, staticRenderFns } from "./BlockType22.vue?vue&type=template&id=d0105390&scoped=true"
import script from "./BlockType22.vue?vue&type=script&lang=ts"
export * from "./BlockType22.vue?vue&type=script&lang=ts"
import style0 from "./BlockType22.vue?vue&type=style&index=0&id=d0105390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0105390",
  null
  
)

export default component.exports